<template>
    <div class="white-box plan-selection__plan text-black mb-5">
        <ul class="choose-plan">
            <li class="choose-plan__item" v-if="cardTitle">
                <span class="choose-plan__item--title">{{getCardTitle()}}</span>
            </li>
            <li v-if="cardContent.length === 0" class="center">
                <v-progress-circular
                    indeterminate
                    color="amber"
                ></v-progress-circular>
            </li>
            <li class="choose-plan__item flex" v-for="(item, index) in cardContent" :key="index">
                <div class="column-1">
                    {{item.label}}
                </div>
                <div class="column-2">
                    {{getItemValue(item.value)}}
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'BankDetailsCard',
    props: {
        cardTitle: String,
        cardDescription: String,
        cardContent: Array,
        hideCheck: Boolean
    },
    methods: {
        getCardTitle () {
            if (this.cardTitle === 'undefined') {
                return null
            }
            return this.cardTitle
        },
        getItemValue (value) {
            if (value === 'undefined' || (value.length === 0)) {
                return null
            }
            return value
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/components/dashboard/dashboard.scss";

.center {
    text-align: center;
}

.flex {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @media (min-width: 992px) {
        flex-direction: row;
    }
}

.column-1 {
    text-align: left;
    width: 100%;
    color: $grey-dark;
    font-weight: 500;
}

.column-2 {
    text-align: left;
    width: 100%;
}

.choose-plan__item--title {
    font-size: $font-size-xs;
    font-weight: $font-weight-medium;
    // flex: 0 0 120px;

    @media (min-width: 992px) {
        font-size: $font-size-base;
    }
}
</style>
